import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { TokenRefreshInterceptor } from './app/core/interceptors/token-refresh.interceptor';
import { ErrorInterceptor } from './app/core/interceptors/error.interceptor';
import { MatNativeDateModule } from '@angular/material/core';
import { importProvidersFrom } from '@angular/core';
import { TokenAccessInterceptor } from './app/core/interceptors/token-acces.interceptor';
import { environment } from './environments/environment';
import { JwtModule } from '@auth0/angular-jwt'
import { TokenSession } from './app/core/models/users.interface';
import { LocalStorageService } from './app/core/services/local-storage/local-storage';
import { provideTerminology } from './app/core/providers/terminology.provider';

export function tokenGetter() {
    const token = localStorage.getItem('token')
    const accesToken = token ? (JSON.parse(token) as TokenSession) : null
    return accesToken?.access ?? null
}

export const dualListSettings = {
  add: 'añadir',
  remove: 'quitar',
  all: 'todos',
  none: 'ninguno',
  direction: 'left-to-right',
  draggable: true,
  locale: 'es',
};

bootstrapApplication(App, {
    providers: [
        provideHttpClient(
            withInterceptors([
                TokenAccessInterceptor,
                TokenRefreshInterceptor,
                ErrorInterceptor,
            ])
        ),
        LocalStorageService,
        provideTerminology(),
        importProvidersFrom(
            JwtModule.forRoot({
                config: {
                    tokenGetter: tokenGetter,
                    allowedDomains: [environment.domain],
                    disallowedRoutes: [`${environment.domain}/login`],
                },
            }),
            MatNativeDateModule
        ),
        provideToastr({
            positionClass: 'toast-top-right',
            timeOut: 3000,
            closeButton: true,
            progressBar: true,
        }),
        provideRouter(routes),
    ],
});
